import React, { useCallback, useEffect, useState } from 'react'
import Grid from '@mui/material/Grid2';
import { faChevronLeft, faChevronRight, faMagnifyingGlass, faPlus } from '@fortawesome/free-solid-svg-icons';
import "./knowledge.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link, useNavigate } from 'react-router-dom';
import { faCalendar, faUser } from '@fortawesome/free-regular-svg-icons';
import { apiService } from '../../services/apiService';
import { ResizableBox } from 'react-resizable';
import { Accordion } from 'react-bootstrap';
function Draft() {
    const navigate = useNavigate();
    const UserRoles = localStorage.getItem('role');
    const [articles, setArticles] = useState([]);
    const [loading, setLoading] = useState(true);
    const [paginatedata, setPaginateData] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [searchQuery, setSearchQuery] = useState("");
    const [typedata, setTypeData] = useState("my_article");
    const permissionstest = JSON.parse(localStorage.getItem('permissions'));
    const [catsloading, setCatsLoading] = useState(false);
    const [catsList, SetlistingCats] = useState([]);
    const [catidsclass, setCatidsclass] = useState("");
    const [catidsbaseclass, setCatidsBaseclass] = useState("");
    const [catidssubclass, setCatidsSubclass] = useState("");

    const fetchData = useCallback(async (params = {}) => {
        setCatsLoading(true);
        try {
            const defaultParams = { status: 'draft', type: typedata, ...params };
            const queryString = new URLSearchParams(defaultParams).toString();
            const response = await apiService.postRequest(`/knowledge-article/sidebar?${queryString}`);
            if (response && response.success === true) {
                SetlistingCats(response.data); 
            }else{
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        }catch (error) {
            console.error('Error fetching tab data:', error);
        } finally {
            setCatsLoading(false);
        }
    }, [typedata]);
    useEffect(() => {
        fetchData();
    }, [fetchData]);
    
    const handleKbaseClick = (kBaseId) => {
        setCatidsBaseclass(kBaseId);   
        setCatidsclass("");
        setCatidsSubclass("");
    };
    const handleCategoryClick = (categoryId) => {
        setCatidsSubclass(categoryId);
        setCatidsclass("");
    };
    const handleSubCategoryClick = (subCategoryId) => {
        setCatidsclass(subCategoryId);
    };
    const fetchArticles = useCallback(async (params = {}) => {
        if(typedata){
        setLoading(true);
        try {
            const defaultParams = { status: 'draft', type: typedata,base_id: catidsbaseclass,category_id: catidssubclass , subcategory_id: catidsclass , ...params };
            const queryString = new URLSearchParams(defaultParams).toString();
            const response = await apiService.getRequest(`/knowledge-article?${queryString}`);
            if (response && response.success === true) {
                setArticles(response.data);
                setPaginateData(response.meta);
            }else{
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {
            console.error('Error fetching tab data:', error);
        } finally {
            setLoading(false);
        }}
    }, [typedata,catidssubclass,catidsclass,catidsbaseclass]);

    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
        fetchArticles({ page: newPage });
    };

    const handleSearch = () => {
        setCurrentPage(1);
        fetchArticles({ search: searchQuery });
    };

    useEffect(() => {
        fetchArticles();
    }, [fetchArticles]);
    useEffect(() => {
        setCatidsBaseclass("");   
        setCatidsclass("");
        setCatidsSubclass("");
    }, [typedata]);
    
  return (
    <div className='container-fluid px-0'>
        <div className="resizable-container d-flex">
            <ResizableBox
                className="knowledge-category"
                width={400}
                height={Infinity}
                minConstraints={[400, Infinity]}
                maxConstraints={[window.innerWidth - 800, Infinity]}
                axis="x"
                resizeHandles={['e']}
            >
                <div className='klgcategory_main dragging_cats'>
                    <div className="knowledge-category-content">
                        <div className='d-flex flex-column'>
                            {catsloading ? 
                            <div className='d-flex justify-content-center w-100'>
                                <img style={{ width: "100px" }} src={require('../../assets/pinkloader.gif')} alt='Loading...' />
                            </div> :<>
                                <Accordion>
                                {catsList && catsList.length > 0 ? (
                                    catsList && catsList.map((catsListings,index) => (
                                    <Accordion.Item eventKey={index} key={catsListings.id}>
                                        <Accordion.Header 
                                        onClick={()=> handleKbaseClick(catsListings.id)} className={catidsbaseclass && catidsbaseclass === catsListings.id ? 'clicked_boldarticle' : ''}
                                        ><div className='div_kbacategory_listwidth'><img src={require('../../assets/chevron-down.svg').default} alt=''/>{catsListings.name}</div>
                                        <span style={{fontWeight:"600"}} className='article_countshow'>{catsListings.articles_count || "0"}</span>
                                        </Accordion.Header>
                                        <Accordion.Body> 
                                            <Accordion defaultActiveKey="0">
                                            {catsListings && catsListings.categories && catsListings.categories.length > 0 ? (
                                                catsListings.categories && catsListings.categories.map((catsmainListings,index) => (
                                                <Accordion.Item eventKey={index} key={catsmainListings.id}>
                                                    <Accordion.Header 
                                                        onClick={()=> handleCategoryClick(catsmainListings.id)} className={catidssubclass && catidssubclass === catsmainListings.id ? 'clicked_boldarticle' : ''}
                                                        >
                                                            <div className='div_kbacategory_listwidth'><img src={require('../../assets/chevron-down.svg').default} alt=''/>{catsmainListings.name}</div>
                                                        <span className='article_countshow'>{catsmainListings.articles_count || "0"}</span>
                                                        </Accordion.Header>
                                                    <Accordion.Body className='ps-0'>  
                                                    <div className='d-flex flex-column'>
                                                        {catsmainListings && catsmainListings.subcategories && catsmainListings.subcategories.length > 0 ? (
                                                            catsmainListings.subcategories && catsmainListings.subcategories.map((sublistings) => (
                                                            <span 
                                                                key={sublistings.id} 
                                                                onClick={() => handleSubCategoryClick(sublistings.id)}
                                                                className={catidsclass && catidsclass === sublistings.id ? 'clicked_boldarticle d-flex align-items-center' : 'd-flex align-items-center'}
                                                            >
                                                                <div className='div_kbacategory_listwidth'>{sublistings.name}</div>
                                                                <span className='article_countshow'>{sublistings.articles_count || "0"}</span>
                                                            </span>))
                                                            ) : (
                                                                <div className="w-100 d-flex justify-content-center">
                                                                    <p>No data to display</p>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </Accordion.Body>
                                                </Accordion.Item>
                                                ))
                                            ) : (
                                                <div className="w-100 d-flex justify-content-center mt-4">
                                                    <p>No data to display</p>
                                                </div>
                                            )}
                                            </Accordion>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    ))
                                    ) : (
                                        <div className="w-100 d-flex justify-content-center mt-4">
                                            <p>No data to display</p>
                                        </div>
                                    )}
                                </Accordion>
                            </>}
                        </div>
                    </div>
                </div>
            </ResizableBox>
            <div className='content_container_articals_drag' style={{ flexGrow: 1 }}>
                <Grid size={{sm:12}} container className="main_jobseeker">
                    <Grid size={{sm:12}} container alignItems="center">
                        <Grid size={{md:8,xs:12}} container flexDirection="column" className="jobseekerhead">
                            <h3>Draft</h3>
                        </Grid>
                        <Grid size={{md:12,xs:12}} container justifyContent="space-between" alignItems="center" className="my-4">
                            <Grid size={{md:4,xs:12}} container flexDirection="column">
                                <div className='d-flex jobseekersearch my-3'>
                                    <div className='col-2'>
                                        <FontAwesomeIcon className='iconcol' icon={faMagnifyingGlass} />
                                    </div>
                                    <div className='col-7'>
                                        <input type='text' placeholder='search'
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e.target.value)}
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                  handleSearch(); // Trigger search on Enter key press
                                                }
                                            }}
                                        />
                                    </div>
                                    <div className='col-3'>
                                        <button onClick={handleSearch}>Search</button>
                                    </div>
                                </div>
                            </Grid>
                            <button className='newadderbtn' onClick={() =>{navigate("/knowledge/add-draft")}}><FontAwesomeIcon className='iconer' icon={faPlus} />New</button>
                            <Grid size={{xs:12}} container justifyContent="flex-start" className="statusselectbtn mb-4">
                                <div className='knowledgetab_btnredirect mt-4'>
                                    <button className={typedata === "my_article" ? "active_tabbtn" : ""} onClick={()=>setTypeData("my_article")}>My Articles</button>
                                    {UserRoles !== "admin" &&
                                        <button className={typedata === "my_group" ? "active_tabbtn" : ""} onClick={()=>setTypeData("my_group")}>My Group Articles</button>
                                    }
                                    {permissionstest && permissionstest.manage_kba_admin === true &&
                                        <button className={typedata === "all" ? "active_tabbtn" : ""} onClick={()=>setTypeData("all")}>All</button>
                                    }
                                </div>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid size={{sm:12}} container justifyContent="center" className="mb-4">
                    {loading ? 
                        <div className='d-flex justify-content-center w-100'>
                            <img style={{ width: "100px" }} src={require('../../assets/pinkloader.gif')} alt='Loading...' />
                        </div> :<>
                        {articles && articles.length > 0 ? (
                            articles && articles.map((article) => (
                            <Grid key={article.id} size={{sm:12}} container justifyContent="center" className="knowledge_lister my-4">
                                <Link style={{textDecoration:"none"}} className='questionskn' to={`/knowledge/edit-article/${article.id}`}><b className="articleformat_id">{article.format_id}</b>{article.title}</Link>
                                <span className='w-100 mb-3'>
                                {article.short_description
                                    ? article.short_description.slice(0, 300) + (article.short_description.length > 300 ? "..." : "")
                                    : "No Data"}
                                </span>
                                <Grid size={{xs:12}} container className="span_griders">
                                    <span><FontAwesomeIcon icon={faUser} className='icon_kn'/><small>Authored by :</small>{article.author.name}</span>
                                    <span><FontAwesomeIcon icon={faCalendar} className='icon_kn'/>{article.created_at}</span>
                                    {article?.is_seen !== true && <span className='end_status'>{article?.display_status}</span>}
                                </Grid>
                            </Grid>
                            ))
                        ) : (
                            <div className="w-100 d-flex justify-content-center mt-4">
                                <p>No data to display</p>
                            </div>
                        )}
                    </>}
                    </Grid>
                    <Grid size={{xs:12}} container justifyContent="center" className="mt-4 pagination_btn">
                        <button className='arrowpaginate'
                            onClick={() => handlePageChange(currentPage - 1)} 
                            disabled={currentPage === 1}>
                            <FontAwesomeIcon icon={faChevronLeft} />
                        </button>
                        {paginatedata && (
                            <div className="pagination">
                                {(() => {
                                const totalPages = paginatedata.last_page > 0 ? paginatedata.last_page : 1;
                                const pages = [];
                                const start = Math.max(2, currentPage - 2);
                                const end = Math.min(totalPages - 1, currentPage + 2);

                                // Always show first page
                                pages.push(
                                    <button
                                    key={1}
                                    onClick={() => handlePageChange(1)}
                                    className={currentPage === 1 ? 'active' : ''}
                                    >
                                    1
                                    </button>
                                );

                                if (start > 2) {
                                    pages.push(<span key="start-ellipsis">...</span>);
                                }

                                for (let i = start; i <= end; i++) {
                                    pages.push(
                                    <button
                                        key={i}
                                        onClick={() => handlePageChange(i)}
                                        className={currentPage === i ? 'active' : ''}
                                    >
                                        {i}
                                    </button>
                                    );
                                }

                                if (end < totalPages - 1) {
                                    pages.push(<span key="end-ellipsis">...</span>);
                                }

                                if (totalPages > 1) {
                                    pages.push(
                                    <button
                                        key={totalPages}
                                        onClick={() => handlePageChange(totalPages)}
                                        className={currentPage === totalPages ? 'active' : ''}
                                    >
                                        {totalPages}
                                    </button>
                                    );
                                }

                                return pages;
                                })()}
                            </div>
                        )}

                        <button className='arrowpaginate'
                            onClick={() => handlePageChange(currentPage + 1)} 
                            disabled={currentPage === paginatedata.last_page}>
                            <FontAwesomeIcon icon={faChevronRight} />
                        </button>
                    </Grid>
                </Grid>
            </div>
        </div>
    </div>
  )
}

export default Draft
